// ============================================================
// 🆕 INICIO: Auth Interceptor - Auditoría Seguridad Fase 5 - 2026-03-15
// ============================================================
// Intercepta respuestas 401/403 del backend para:
// - 401 (Token inválido/expirado): Logout automático + redirect a login
// - 403 (Sin permisos): Notificación al usuario sin logout
// Usa Injector lazy para evitar dependencia circular con HttpClient.
// Autor: Claude Code
// ============================================================

import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { MensajesService } from 'src/app/services/mensajes.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private _injector: Injector,
    private _router: Router,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token inválido o expirado → logout automático
          const sharedService = this._injector.get(SharedService);
          sharedService.logOutUser();
          this._router.navigate(['/public/login']);
        } else if (error.status === 403) {
          // Sin permisos para este recurso
          const mensajes = this._injector.get(MensajesService);
          mensajes.mensajes_info('No tiene permisos para realizar esta acción.');
        }
        return throwError(() => error);
      }),
    );
  }
}

// ============================================================
// 🆕 FIN: Auth Interceptor
// ============================================================
